import { CalendarService } from "@/services/calendar/calendar.service";
import { RoleManagementService } from "@/services/role-management/role-management.service";
import { UserManagementService } from "@/services/user-management/user-management.service";
import {
  Location
} from "@angular/common";
import { Component, ElementRef, HostListener, OnInit, ViewChild } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { Calendar } from "src/app/class/calendar";
import Swal from "sweetalert2";
import * as XLSX from "xlsx-js-style";

import {
  MENU_ADMIN,
  MENU_EMPLOYEE,
  MENU_HR,
  MENU_MANAGER,
  MENU_MANAGING_DIRECTORN
} from "../sidebar/sidebar.component";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit {
  public focus;
  public listTitles: any[];
  public location: Location;

  fname = localStorage.getItem("fname");
  lname = localStorage.getItem("lname");
  role = localStorage.getItem("role");
  userId = localStorage.getItem("UserId");
  positionName = localStorage.getItem("positionName");
  fullname = this.fname + "  " + this.lname;
  menu = [];
  dataMenu = [];
  dataRole = [];
  minRole = [];
  dataList: any[] = [];
  constructor(
    location: Location,
    private element: ElementRef,
    private router: Router,
    public roleManagementService: RoleManagementService,
    public userManagementService: UserManagementService,
    public modalService: NgbModal,
    private _service: CalendarService,
  ) {
    this.location = location;
  }
  closeModal: string;

  calendar = new Calendar();
  selectedFiles: File[] = [];
  hasSelectedFiles: boolean = false;
  year: any;
  // date: any;
  // description: any;
  isRouteActive(path: string): boolean {
  // กรณีพิเศษสำหรับ verify-timesheet
    if (path === '/verify-timesheet') {
      return this.router.url.includes('/verify-timesheet') || 
             this.router.url.includes('/verify-timesheet-view');
    } else if (path === '/my-timesheet') {
      return this.router.url.includes('/my-timesheet') || 
             this.router.url.includes('/list-by-month');
    }
    const currentPath = this.router.url.split('?')[0];
    
    return currentPath === path || currentPath.startsWith(path + '/');
  }


  ngOnInit() {
    this.userManagementService
      .getMsUserById(this.userId)
      .subscribe((res: any) => {
        res.msUserRoleModelList.forEach((data) => {
          this.dataRole.push(data.roleId);
        });
        this.minRole.push(Math.min.apply(Math, this.dataRole));
      });
    this.router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        // Close navbar on route change (menu item clicked)
        this.closeNavbar();

        if (event.url == "/first-time-management") {
          this.element.nativeElement.classList.add("d-none");
        } else if (event.url == "/reset-password") {
          this.element.nativeElement.classList.add("d-none");
        } else if (event.url == "/pdpa") {
          this.element.nativeElement.classList.add("d-none");
        } else {
          this.element.nativeElement.classList.remove("d-none");
        }
      }
    });
    if (this.router.url == "/first-time-management") {
      this.element.nativeElement.classList.add("d-none");
    } else if (this.router.url == "/reset-password") {
      this.element.nativeElement.classList.add("d-none");
    } else if (this.router.url == "/pdpa") {
      this.element.nativeElement.classList.add("d-none");
    } else {
      this.element.nativeElement.classList.remove("d-none");
    }

    this.getMenuByRole();
    // this.listTitles = MENU_EMPLOYEE.filter((listTitle) => listTitle);
    this.getMenu();
    this.year = new Date().getFullYear();
  }

  // Close navbar when clicking outside
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const navbar = this.element.nativeElement.querySelector('.navbar-collapse');
    const togglerButton = this.element.nativeElement.querySelector('.navbar-toggler');
    const clickedInside = this.element.nativeElement.contains(event.target);

    // Check if navbar is open and click is outside
    if (navbar && navbar.classList.contains('show') && !clickedInside) {
      this.closeNavbar();
    }
  }

  // Method to close the navbar programmatically
  closeNavbar() {
    const navbar = this.element.nativeElement.querySelector('.navbar-collapse');
    if (navbar && navbar.classList.contains('show')) {
      // Remove the 'show' class to collapse the navbar
      navbar.classList.remove('show');
    }
  }

  getTitle() {
    var titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === "#") {
      titlee = titlee.slice(1);
    }

    for (var item = 0; item < this.listTitles.length; item++) {
      if (this.listTitles[item].path === titlee) {
        return this.listTitles[item].title;
      }
    }
    return "Dashboard";
  }

  getMenuByRole() {
    const MENU_ROLE_ADMIN = MENU_ADMIN.filter((listTitle) => listTitle);
    const MENU_ROLE_MANAGER = MENU_MANAGER.filter((listTitle) => listTitle);
    const MENU_ROLE_HR = MENU_HR.filter((listTitle) => listTitle);
    const MENU_ROLE_EMPLOYEE = MENU_EMPLOYEE.filter((listTitle) => listTitle);
    const MENU_ROLE_MD = MENU_MANAGING_DIRECTORN.filter(
      (listTitle) => listTitle
    );
    let roles: String = JSON.parse(localStorage.getItem("roleName"));
    console.log("MENU >>>", MENU_ROLE_MANAGER);
    if (
      roles.includes("ADMIN") &&
      this.positionName.includes("Managing Director")
    )
      return (this.listTitles = MENU_ROLE_MD);
    if (
      roles.includes("ADMIN") &&
      this.positionName.includes("Human Resources")
    )
      return (this.listTitles = MENU_ROLE_HR);

    if(roles.includes("EMPLOYEE") && this.positionName.includes("Project Management Officer")) return (this.listTitles = MENU_ROLE_MANAGER);


    if (roles.includes("ADMIN")) return (this.listTitles = MENU_ROLE_ADMIN);
    if (roles.includes("MANAGER")) return (this.listTitles = MENU_ROLE_MANAGER);
    if (roles.includes("EMPLOYEE")) return (this.listTitles = MENU_ROLE_EMPLOYEE);

  }

  getMenu() {
    let uniqueIds = [];
    this.roleManagementService.getMsRoleAll().subscribe((res: any) => {
      res.forEach((data: any) => {
        if (this.role.includes(data.id)) {
          data.msRoleMenuModelList.forEach((item: any) => {
            this.menu.push({ id: item.menuId, title: item.menuName });
          });
        }
      });

      this.listTitles.forEach((item: any) => {
        this.menu.forEach((data, index) => {
          if (data.id == item.id) {
            this.dataMenu.push({
              id: item.id,
              title: this.menu[index].title,
              path: item.path,
              icon: item.icon,
            });
          }
        });
      });

      const newValue = {
        title: "Dashboard",
        path: "/dashboard",
        icon: "fa fa-home",
      };

      this.dataMenu = [newValue].concat(this.dataMenu);
      const unique = this.dataMenu.filter((res: any) => {
        const isDuplicate = uniqueIds.includes(res.id);
        if (!isDuplicate) {
          uniqueIds.push(res.id);
          return true;
        }

        return false;
      });

      this.dataMenu = unique;
    });
    console.log("DATAMENU>>>", this.dataMenu);
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  popupTime(content: any) {
    console.log("Popup");
    this.modalService
      .open(content, {
        ariaLabelledBy: "modal-basic-title",
        // size: "lg",
        windowClass: "zinfexFixed",
      })
      .result.then(
        (res) => {
          // ------ กดปุ่ม Close ------
          this.closeModal = `Closed with: ${res}`;
        },
        (res) => {
          // ------ Action ตอนกด Esc หรือกดออกเองแบบไม่กดปุ่ม Close ------
          this.closeModal = `Dismissed ${this.getDismissReason(res)}`;
        }
      );
  }

  funcCloseMOdel(modal: any) {
    modal.close("Back click");
  }

  // Export Holiday Template
  @ViewChild("tableHoliday") table: ElementRef;
  onExportHoliday() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.table.nativeElement
    );

    ws["!cols"][1] = { width: 15 };
    ws["!cols"][2] = { width: 40 };

    ws.A1.s = {
      alignment: { horizontal: "center" },
      font: { bold: true, sz: 12 },
    };
    ws.A2.s = {
      alignment: { horizontal: "center" },
    };
    ws.B2.s = {
      alignment: { horizontal: "center" },
    };
    ws.C2.s = {
      alignment: { horizontal: "center" },
    };

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Import");

    /* save to file */
    XLSX.writeFile(wb, "holiday.xlsx");
  }

  onFileSelected(event: any): void {
    this.selectedFiles = event.target.files;
    this.hasSelectedFiles = this.selectedFiles.length > 0;
  }

  addCalendar(): void {
    Swal.fire({
      title: "Do you want to import excel?",
      showCancelButton: true,
      cancelButtonColor: "#ff4444",
      confirmButtonText: "Save",
      confirmButtonColor: "#00c851",
    }).then((result) => {
      console.log("Result>>>",result);
      if (result.isConfirmed) {
        const fileReader = new FileReader();
        fileReader.onload = (e) => {
          const arrayBuffer = fileReader.result as ArrayBuffer;
          const data = new Uint8Array(arrayBuffer);
          const workbook = XLSX.read(data, { type: "array", cellDates: true });
          const worksheet = workbook.Sheets[workbook.SheetNames[0]];
          this.dataList = XLSX.utils.sheet_to_json(worksheet, {
            header: 2, //key row 4
            range: 1, //read value row 5
          });
          // console.log("Holiday0 >>>",workbook);
          this.dataList.map((data) => {
            const date = data.Date;
            const description = data.Day_Description;
            this.calendar.dayOff = moment(new Date(date), "YYYY-MM-DD").subtract(-1, "days").toDate();
            // this.holiday.dayOff = moment(date).format("YYYY-MM-DD");
            this.calendar.dayDesc = description;
            console.log("Holiday >>>",this.calendar);
            if (date == null || typeof date === "undefined" || date === undefined || date == "undefined") {
              Swal.fire({
                icon: "error",
                title: "Error...",
                text: '"Date" is no value',
              });
            }
            else if (typeof date == "string" || typeof date == "number") {
              Swal.fire({
                icon: "error",
                title: "Error...",
                text: '"Date" is not format.',
              });
            }
            else if (description == null || description == "") {
              Swal.fire({
                icon: "error",
                title: "Error...",
                text: '"Day_Description" is no value.',
              });
            }
            else {
              this._service.addMsCalendar(this.calendar)
              .subscribe((data) => {console.log("Success")});
              Swal.fire({
                icon: "success",
                title: "Success...",
                text: 'Holiday uploaded successfully.',
              }).then((res) => {
                window.location.reload();
              });
            }

          });
        };
        fileReader.readAsArrayBuffer(this.selectedFiles[0]);
      }
      return false;
    });
  }
}


